module.exports = __webpack_public_path__ + "img/2.31f09b49.png";